import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import classnames from 'classnames';
import { Theme } from '@app/theme';
import { GenericButton, GenericButtonProps } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  link: {
    ...theme.fonts.body,
    color: theme.colors.blueAccessible,
    display: 'inline-flex',
    alignItems: 'center',
  },
  buttonSize: {
    height: theme.height.regular,
  },
  arrowIcon: {
    fontSize: theme.iconSize.regular,
    fontWeight: 'lighter',
  },
  addIcon: {
    fontSize: theme.iconSize.regular,
    fontWeight: 'lighter',
  },
  arrowRight: {
    marginLeft: theme.marginBase,
  },
  arrowLeft: {
    marginRight: theme.marginBase,
  },
  externalLinkIcon: {
    marginLeft: theme.marginBase / 2,
  },
}));

interface SpecialProps {
  className?: string;
  arrowLeft?: boolean;
  arrowRight?: boolean;
  buttonSize?: boolean;
  isExternalLink?: boolean;
  addLeft?: boolean;
}

type Props = SpecialProps & GenericButtonProps;

export const Link = ({
  className,
  arrowLeft,
  arrowRight,
  isExternalLink,
  buttonSize,
  children,
  addLeft,
  ...props
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <GenericButton
      {...props}
      className={classnames(
        classes.link,
        {
          [classes.buttonSize]: buttonSize,
        },
        className,
      )}
    >
      {!!arrowLeft && (
        <i
          className={classnames(
            'ri-arrow-left-line',
            classes.arrowIcon,
            classes.arrowLeft,
          )}
        />
      )}
      {!!addLeft && (
        <i
          className={classnames(
            'ri-add-line',
            classes.addIcon,
          )}
        />
      )}
      {children}
      {!!arrowRight && (
        <i
          className={classnames(
            'ri-arrow-right-line',
            classes.arrowIcon,
            classes.arrowRight,
          )}
        />
      )}
      {!!isExternalLink && (
        <i
          className={classnames(
            'ri-share-box-line',
            classes.externalLinkIcon,
            classes.arrowRight,
          )}
        />
      )}
    </GenericButton>
  );
};
